import WidgetTitle, { WidgetTitleProps } from '../WidgetTitle'
import Card from '../Card'
import React from 'react'
import './widgetCard.less'
import classNames from 'classnames'

interface Props extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode
  widgetTitle: WidgetTitleProps
  collapsible?: {
    collapsed?: boolean
    toggleCollapsed?: () => void
  }
  cardBordered?: boolean
}

const WidgetCard = (props: Props) => {
  const { children, widgetTitle, collapsible, cardBordered = false, ...rest } = props

  return (
    <Card
      cardTitle={
        <WidgetTitle
          {...widgetTitle}
          toggleCollapsed={collapsible?.toggleCollapsed}
          isCollapsible={Boolean(collapsible)}
          collapsed={collapsible?.collapsed}
        />
      }
      collapsed={collapsible?.collapsed}
      {...rest}
      className={classNames(rest.className, { 'card-bordered': cardBordered })}
    >
      {children}
    </Card>
  )
}

export default WidgetCard
